import base from './base'
import neutral from './neutral'
import voicetome from './voicetome'

export const DEFAULT_THEME = 'base'

// For pages that must not carry any partner identity — see neutral.js
export const NEUTRAL_THEME = 'neutral'

export const themes = {
  base,
  neutral,
  voicetome,
}
